// F2 org analytics client. Wraps the real backend endpoints
// (backend/app/routers/analytics.py):
//   GET /analytics/orgs/{id}/{revenue,revenue-trend,member-count,member-trend}
// These now carry backend response_models (#1393), so the response shapes are
// the generated aliases — re-exported here so consumers keep importing from this
// lib. `revenue` is a branded Money (`number | string`) → narrow with
// parseDecimal/formatMoney, never raw arithmetic.
import { httpClient } from "@bw/shared/api"
import type {
  OrgMemberCountResponse,
  OrgMemberTrendPoint,
  OrgMemberTrendResponse,
  OrgRevenueResponse,
  OrgRevenueTrendPoint,
  OrgRevenueTrendResponse,
} from "@bw/shared/types/generated"

export type {
  OrgMemberCountResponse,
  OrgMemberTrendPoint,
  OrgMemberTrendResponse,
  OrgRevenueResponse,
  OrgRevenueTrendPoint,
  OrgRevenueTrendResponse,
}

export function getOrgRevenue(
  orgId: string,
  start: string,
  end: string,
): Promise<OrgRevenueResponse> {
  return httpClient.get<OrgRevenueResponse>(
    `/analytics/orgs/${encodeURIComponent(orgId)}/revenue?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`,
  )
}

export function getOrgMemberCount(orgId: string): Promise<OrgMemberCountResponse> {
  return httpClient.get<OrgMemberCountResponse>(
    `/analytics/orgs/${encodeURIComponent(orgId)}/member-count`,
  )
}

export function getOrgRevenueTrend(
  orgId: string,
  start: string,
  end: string,
  buckets = 6,
): Promise<OrgRevenueTrendResponse> {
  return httpClient.get<OrgRevenueTrendResponse>(
    `/analytics/orgs/${encodeURIComponent(orgId)}/revenue-trend?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&buckets=${buckets}`,
  )
}

export function getOrgMemberTrend(
  orgId: string,
  start: string,
  end: string,
  buckets = 6,
): Promise<OrgMemberTrendResponse> {
  return httpClient.get<OrgMemberTrendResponse>(
    `/analytics/orgs/${encodeURIComponent(orgId)}/member-trend?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&buckets=${buckets}`,
  )
}
